// 名师工作室页面
import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './MSGZSList.module.css'
import {
  message,
  Space,
  Tabs,
  List,
  Image,
  Tag,
  Modal,
} from 'antd'
import HeaderBar from './HeaderBar'
import teacherImg from './teacherImg.svg'
import {
  addTeacherClickNumRequest,
  getDataListRequest,
} from './MSGZSListApi'
import videoImg from './ic_video.svg'
import fileImg from './ic_file.svg'
import botImg from './ic_bot.svg'
import MSInfoPage from './MSInfoPage'

export default function MSGZSList(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [dataList, setDataList] = useState([])
  const [showMSInfo, setShowMSInfo] = useState(false)
  const [MSInfo, setMSInfo] = useState('')
  const [showVideo, setShowVideo] = useState(false)

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getDataList('')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function createBotMethod(params) {
    props.jumpToCreateBot(31)
  }

  const getDataList = (namekey) => {
    getDataListRequest(namekey, (res) => {
      console.log(res)
      if (res.ret == 1) {
        setDataList(res.data.data)
      } else {
        setDataList([])
        message.error(res.msg)
      }
    })
  }

  const IconText = ({ icon, text }) => (
    // <Space align='center' >
    //   {/* {React.createElement(icon)} */}
    //   <img src={icon} style={{width:30,height:30}}/>
    //   <span>{text}</span>
    // </Space>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 16,
      }}
    >
      <img src={icon} style={{ width: 30, height: 30, marginRight: 8 }} />
      <span>{text}</span>
    </div>
  )
  const jumpToTeacher = (info) => {
    addTeacherClickNumRequest(info.username, (res) => {
      if (res.ret == 1) {
        setMSInfo(info)
        setShowMSInfo(true)
      } else {
        message.warning(res.msg)
      }
    })
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      <HeaderBar
        createBot={createBotMethod}
        confirmSearch={(e) => {
          getDataList(e)
        }}
      />

      <List
        style={{
          backgroundColor: 'white',
          margin: '20px 64px',
          borderRadius: 16,
        }}
        header={
          <div style={{ marginLeft: 16 }}>
            <h3>名师工作室列表</h3>
          </div>
        }
        split={true}
        // loading={true}

        itemLayout="vertical"
        size="large"
        dataSource={dataList}
        renderItem={(item) => (
          <List.Item
            key={item.Id}
            extra={
              <Space align="center" direction="vertical">
                <Image
                  width={125}
                  height={160}
                  alt="logo"
                  src={item.image_url}
                  // style={{  }}
                  style={{
                    borderRadius: 12,
                    objectFit: 'cover',
                    // 边框样式
                    border: '0px solid #e0e0e0',
                    borderRadius: '8px',
                    // 阴影样式
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
                    // 避免阴影被截断
                    overflow: 'hidden',
                  }}
                />
                <div
                  className={styles.lookMainPage}
                  onClick={() => {
                    jumpToTeacher(item)
                  }}
                >
                  查看主页
                </div>
              </Space>
            }
            style={{ marginBottom: 24 }}
          >
            <List.Item.Meta
              title={item.name}
              // description={item.personal_profile}
              description={
                <span style={{ color: 'rgba(0,0,0,0.88)' }}>
                  {item.personal_profile}
                </span>
              }
              style={{ height: 166, cursor: 'pointer' }}
              onClick={() => {
                jumpToTeacher(item)
              }}
            />
            <Space align="center" direction="horizontal">
              <IconText
                icon={videoImg}
                text={'教学视频  ' + item.video_num}
                key="list-vertical-star-o"
              />
              <IconText
                icon={fileImg}
                text={'精选课件  ' + item.file_num}
                key="list-vertical-like-o"
              />
              <IconText
                icon={botImg}
                text={'名师智能体  ' + item.coze_bot_num}
                key="list-vertical-message"
              />
            </Space>
          </List.Item>
        )}
      />
      {showMSInfo ? (
        <MSInfoPage
          info={MSInfo}
          close={() => {
            setShowMSInfo(false)
            setMSInfo('')
          }}
        />
      ) : null}
    </div>
  )
}
